// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ZmIU","absolute":"Footer_absolute__1UhbN","links":"Footer_links__3hdOW","btn":"Footer_btn__19H3h","link":"Footer_link__3habo","copy":"Footer_copy__2CSCU"};